import { PublicService, ApiService } from '@DavisDigital/davisdigitalfrontend.module';
import { FoldersAPIResponse } from '@DavisDigital/interfaces';

export class LessonService {
	// Cached sample lessons.
	private sampleLessons: any = {};

	// Cached my lessons.
	private myLessons: any = {};
	private myLessonFolders: any = {};

	// Cached my lessons.
	private sharedLessons: any = {};
	private sharedLessonFolders: any = {};

	//@ngInject
	constructor(
		private $q: ng.IQService,
		private apiService: ApiService,
		private publicService: PublicService,
		private davisAlertService,
	) {}

	/**
	 * Get Sample Lessons
	 *
	 * @async
	 * @param {any} args - arguments with key - value pairings.
	 * @return {Promise<any>} Books object organized by school
	 */
	public getSampleLessons = (args: any = {}): ng.IPromise<any> => {
		if (args.bustCache) {
			this.sampleLessons = [];
		}
		var deferred = this.$q.defer<any>();

		let data = {
			'P:Current': args.currentPage || 1,
			'P:Show': args.recordsPerPage || 4,
			'P:Sort': args.sortOrder || 2,
			'keywords': args.keywords,
			'folderID': args.folder?.folderID,
		};

		let cacheKey = `${JSON.stringify(data)}`;

		if (this.sampleLessons[cacheKey]) {
			deferred.resolve(this.sampleLessons[cacheKey]);
			return deferred.promise;
		}

		this.apiService
			.request('davisdigital:api.getSampleLessons', data)
			.then((result) => {
				this.sampleLessons[cacheKey] = result.data.data;

				deferred.resolve(this.sampleLessons[cacheKey]);
			})
			.catch((result) => {
				deferred.reject(result);
			});

		return deferred.promise;
	};

	/**
	 * Get My Lessons
	 *
	 * @async
	 * @param {any} args - arguments with key - value pairings.
	 * @return {Promise<any>} Books object organized by school
	 */
	public getMyLessons = (args: any = {}): ng.IPromise<any> => {
		if (args.bustCache) {
			this.myLessons = [];
		}

		var deferred = this.$q.defer();

		let data = {
			'P:Current': args.currentPage || 1,
			'P:Show': args.recordsPerPage || 4,
			'P:Sort': args.sortOrder || 2,
			'keywords': args.keywords,
			'folderID': args.folder?.folderID || args.folderID,
			'includeFolderLessons': args?.includeFolderLessons
		};

		let cacheKey = `${JSON.stringify(data)}`;

		if (this.myLessons[cacheKey]) {
			deferred.resolve(this.myLessons[cacheKey]);
			return deferred.promise;
		}

		this.apiService
			.request('davisdigital:api.getMyLessons', data)
			.then((result) => {
				this.myLessons[cacheKey] = result.data.data;

				deferred.resolve(this.myLessons[cacheKey]);
			})
			.catch((result) => {
				deferred.reject(result);
			});

		return deferred.promise;
	};

	/**
	 * Get My Lesson Folders
	 *
	 * @async
	 * @param {any} args - arguments with key - value pairings.
	 * @return {Promise<any>} Books object organized by school
	 */
	public getMyLessonFolders = (args: any = {}): ng.IPromise<any> => {
		if (args.bustCache) {
			this.myLessonFolders = [];
		}
		var deferred = this.$q.defer();

		let data: any = {
			'P:Current': args.currentPage || 1,
			'P:Show': args.recordsPerPage || 4,
			'P:Sort': args.sortOrder || 2,
			'keywords': args.keywords,
			'folderID': args.folder?.folderID || args.folderID,
		    'showAll': args?.showAll,
		    'ignoreArchiveFolder': args?.ignoreArchiveFolder || false,
		};

		let cacheKey = `${JSON.stringify(data)}`;

		if (data.showAll) {
			cacheKey = 'all';
		}

		if (this.myLessonFolders[cacheKey]) {
			deferred.resolve(this.myLessonFolders[cacheKey]);
			return deferred.promise;
		}

		this.apiService
			.request('davisdigital:api.getMyLessonFolders', data)
			.then((result) => {
				this.myLessonFolders[cacheKey] = result.data;
				deferred.resolve(this.myLessonFolders[cacheKey]);
			})
			.catch((result) => {
				deferred.reject(result);
			});

		return deferred.promise;
	};

	/**
	 * Get Shared Lessons
	 *
	 * @async
	 * @param {any} args - arguments with key - value pairings.
	 * @return {Promise<any>} Books object organized by school
	 */
	public getSharedLessons = (args: any = {}): ng.IPromise<any> => {
		if (args.bustCache) {
			this.sharedLessons = [];
		}
		var deferred = this.$q.defer();

		let data = {
			'P:Current': args.currentPage || 1,
			'P:Show': args.recordsPerPage || 4,
			'P:Sort': args.sortOrder || 2,
			'keywords': args.keywords,
			'folderID': args.folder?.folderID || args.folderID,
			'sharedByAccountID': args.sharedByAccount,
		};

		let cacheKey = `${JSON.stringify(data)}`;

		if (this.sharedLessons[cacheKey]) {
			deferred.resolve(this.sharedLessons[cacheKey]);
			return deferred.promise;
		}

		this.apiService
			.request('davisdigital:api.getSharedLessons', data)
			.then((result) => {
				this.sharedLessons[cacheKey] = result.data.data;

				deferred.resolve(this.sharedLessons[cacheKey]);
			})
			.catch((result) => {
				deferred.reject(result);
			});

		return deferred.promise;
	};

	/**
	 * Get Shared Lesson Folders
	 *
	 * @async
	 * @param {any} args - arguments with key - value pairings.
	 * @return {Promise<any>} Books object organized by school
	 */
	public getSharedLessonFolders = (args: any = {}): ng.IPromise<any> => {
		if (args.bustCache) {
			this.sharedLessonFolders = [];
		}
		var deferred = this.$q.defer();

		let data = {
			'P:Current': args.currentPage || 1,
			'P:Show': args.recordsPerPage || 4,
			'P:Sort': args.sortOrder || 2,
			'keywords': args.keywords,
			'sharedByAccountID': args.sharedByAccount,
			'folderType': args.folderType,
		};

		let cacheKey = `${JSON.stringify(data)}`;

		if (this.sharedLessonFolders[cacheKey]) {
			deferred.resolve(this.sharedLessonFolders[cacheKey]);
			return deferred.promise;
		}

		this.apiService
			.request('davisdigital:api.getSharedLessonFolders', data)
			.then((result) => {
				this.sharedLessonFolders[cacheKey] = result.data.data;
				console.log(this.sharedLessonFolders[cacheKey]);

				deferred.resolve(this.sharedLessonFolders[cacheKey]);
			})
			.catch((result) => {
				deferred.reject(result);
			});

		return deferred.promise;
	};
	
	/**
	 * Get Lessons For Folder
	 *
	 * @async
	 * @param {any} args - folderID
	 * @return {Promise<any>} List of lessons
	 */
	public getFolderLessons = (args: any = {}): ng.IPromise<any> => {
		
		var deferred = this.$q.defer();

		let data = {
			'folderID': args.folderID
		};

		this.apiService
			.request('davisdigital:api.getFolderLessons', data)
			.then((result) => {
				deferred.resolve(result.data.data);
			})
			.catch((result) => {
				deferred.reject(result);
			});

		return deferred.promise;
	};

	/**
	 * Create a New Folder
	 * TODO: remove this and use one from ContentService
	 *
	 * @param title
	 * @return {Promise}
	 */
	public createFolder = ( title : string, folderType: string ): ng.IPromise<any> => {
		
		let deferred = this.$q.defer();

		let slatAction = 'davisdigital:api.createFolder';
		
		let data = {'title': title, "folderType": folderType};
		
		this.apiService.request( slatAction, data).then( result => {
			deferred.resolve( result.data );
		}).catch( result => {
			deferred.reject( result );
		});
		
		return deferred.promise;
	};

	public createLesson = (title: string, folderID ?: string, lesson ?: object, description ?: string ): ng.IPromise<any> => {
		let deferred = this.$q.defer();

		let data = { title, folderID, lesson, description };

		this.apiService
			.request('davisdigital:api.createLesson', data)
			.then( (result) => {
				deferred.resolve(result.data);
			})
			.catch((result) => {
				deferred.reject(result);
			});

		return deferred.promise;
	};
	
	public publishLesson = (lesson): ng.IPromise<any> =>{
		let deferred = this.$q.defer();

		let data: any = {
			lessonID: lesson.lessonID,
		};
		
		this.apiService
		.request('davisdigital:api.publishLesson', data)
		.then((result) => {
			deferred.resolve(result.data);
		})
		.catch((result) => {
			deferred.reject(result);
		});
		
		return deferred.promise; 
	}
	
	public unpublishLesson = (lesson): ng.IPromise<any> =>{
		let deferred = this.$q.defer();

		let data: any = {
			lessonID: lesson.lessonID,
		};
		
		this.apiService
		.request('davisdigital:api.unpublishLesson', data)
		.then((result) => {
			deferred.resolve(result.data);
		})
		.catch((result) => {
			deferred.reject(result);
		});
		
		return deferred.promise; 
	}

	public saveLesson = (lesson, args?): ng.IPromise<any> => {
		let deferred = this.$q.defer();

		let data: any = {
			lesson: lesson,
		};

		if (args?.contentModule != null) {
			data.contentModule = args.contentModule;
		}

		this.apiService
			.request('davisdigital:api.saveLesson', data)
			.then((result) => {
				
				//show error message if available in response
				if(!result.data.data.success && result.data.data.message != "") {
					this.davisAlertService.error( result.data.data.message );
				}
				
				deferred.resolve(result.data);
			})
			.catch((result) => {
				deferred.reject(result);
			});

		return deferred.promise;
	};

	public getLessonDetails = (lessonID): ng.IPromise<any> => {
		let deferred = this.$q.defer();

		let data = {
			lessonID: lessonID,
		};

		this.apiService
			.request('davisdigital:api.getLessonDetails', data)
			.then((result) => {
				deferred.resolve(result.data);
			})
			.catch((result) => {
				deferred.reject(result);
			});

		return deferred.promise;
	};

	/**
	 * Move Lesson to Folder
	 *
	 * @param title
	 * @return {Promise}
	 */
	public moveLesson = (lessonID: string, folderID: string): ng.IPromise<any> => {
		let deferred = this.$q.defer();

		let slatAction = 'davisdigital:api.moveLesson';

		let data = { lessonID: lessonID, folderID: folderID };

		this.apiService
			.request(slatAction, data)
			.then((result) => {
				deferred.resolve(result.data);
			})
			.catch((result) => {
				deferred.reject(result);
			});

		return deferred.promise;
	};
	
    // TODO, remove this and use one from ContentService
	public removeAccountAccess = (accountID, baseObjectID): ng.IPromise<any> => {
		let deferred = this.$q.defer();

		let data: any = {
			accountID: accountID,
			baseObjectID: baseObjectID,
		};

		this.apiService
			.request('davisdigital:api.removeAccountAccess', data)
			.then((result) => {
				deferred.resolve(result.data);
			})
			.catch((result) => {
				deferred.reject(result);
			});

		return deferred.promise;
	};

    
    // TODO, remove this and use one form ContentService
	public renameFolder = (title, folderID): ng.IPromise<any> => {
		let deferred = this.$q.defer();

		let data: any = {
			title: title,
			folderID: folderID,
		};
		this.apiService
			.request('davisdigital:api.renameFolder', data)
			.then((result) => {
				deferred.resolve(result.data);
			})
			.catch((result) => {
				deferred.reject(result);
			});

		return deferred.promise;
	};
	
	/**
	 * Delete Lesson
	 *
	 * @param title
	 * @return {Promise}
	 */
	public deleteLesson = (lessonID: string): ng.IPromise<any> => {
		let deferred = this.$q.defer();

		let slatAction = 'davisdigital:api.deleteLesson';
		let data = { lessonID: lessonID};

		this.apiService
			.request(slatAction, data)
			.then((result) => {
				deferred.resolve(result.data);
			})
			.catch((result) => {
				deferred.reject(result);
			});

		return deferred.promise;
	};
	
	public duplicateLesson = (
	    lessonID: string,
	    title:string,
	    folderID:string = ""
	): ng.IPromise<any> => {
		
		let deferred = this.$q.defer();

		let slatAction = 'davisdigital:api.duplicateLesson';
		let data = { lessonID: lessonID, folderID:folderID, title:title};

		this.apiService
			.request(slatAction, data)
			.then((result) => {
			    if( !result?.data?.successfulActions?.includes('duplicateLesson') ){
	                throw(result);
	            }
				deferred.resolve(result.data);
			})
			.catch(deferred.reject);

		return deferred.promise;
	};
}
